export var StakeButtonsModifiers;
(function (StakeButtonsModifiers) {
    StakeButtonsModifiers["Minus"] = "minus";
    StakeButtonsModifiers["Plus"] = "plus";
})(StakeButtonsModifiers || (StakeButtonsModifiers = {}));
//# sourceMappingURL=StakeButtonsModifiers.js.map